//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 460,
                    y: 120,
                    scale: 1.5
                },
                {
                    x: 980,
                    y: 400,
                    scale: 1.5
                },
                {
                    x: 630,
                    y: 610,
                    scale: 1.5
                },
                {
                    x: 430,
                    y: 570,
                    scale: 1.9
                },
                {
                    x: 640,
                    y: 120,
                    scale: 1.5
                }
            ]
        };
    }
};
